/// <reference path="wpt.ts" />
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var WPTNamespace;
(function (WPTNamespace) {
    var Utilities;
    (function (Utilities) {
        const LOG_CATEGORY = "WPT.Helper";
        const DEFAULT_NARROW_WIDTH = 768;
        const DEFAULT_SHORT_HEIGHT = 768;
        const REMOTE_DELIMITER = "@|@";
        /**
         * Class for helper functionality. Depends on WPT "modules": Loader, Locale, Config.
         */
        class HelperFunctions {
            constructor(core) {
                this._log = null;
                this._idpBusyModalActive = null;
                this._narrowWidth = null;
                this._shortHeight = null;
                this._messageModalHtml = null;
                this._warnContModalHtml = null;
                this._warnServiceModalHtml = null;
                this._datasetSelectionModalHtml = null;
                this._idpBusyModalHtml = null;
                this._busyModalHtml = null;
                this._currentMessageModalSession = null;
                this._currentIdPBusyModalSession = null;
                this._currentDataSelectionModalSession = null;
                this._iconMapping = [];
                this._wvViewConfigMap = {};
                this._wvFormMap = {};
                this._spinnerSvg = null;
                this._busyModalsReady = [];
                this._busyModalsCloseRequested = [];
                this.init = () => {
                    this._log.info("HelperFunctions.init()");
                    this._idpBusyModalActive = false;
                    this._narrowWidth = null;
                    this._shortHeight = null;
                    this._iconMapping = [];
                    this._spinnerSvg = null;
                    let mainConfig = this._core.Config.getMainConfig();
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('Layout')) {
                        let layoutConfig = appConfig.Layout;
                        if (layoutConfig.hasOwnProperty('NarrowDeviceWidth')) {
                            this._narrowWidth = layoutConfig.NarrowDeviceWidth;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("set narrow width from application config: " + this._narrowWidth);
                            }
                        }
                        if (layoutConfig.hasOwnProperty('ShortDeviceHeight')) {
                            this._shortHeight = layoutConfig.ShortDeviceHeight;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("set short height from application config: " + this._shortHeight);
                            }
                        }
                    }
                    if (appConfig.hasOwnProperty('IconMapping')) {
                        this._iconMapping = appConfig.IconMapping;
                    }
                    else if (mainConfig.hasOwnProperty('IconMapping')) {
                        this._iconMapping = mainConfig.IconMapping;
                    }
                    if (this._narrowWidth == null || this._shortHeight == null) {
                        if (this._narrowWidth == null && mainConfig.hasOwnProperty('NarrowDeviceWidth')) {
                            this._narrowWidth = mainConfig.NarrowDeviceWidth;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("set narrow width from main config: " + this._narrowWidth);
                            }
                        }
                        if (this._shortHeight == null && mainConfig.hasOwnProperty('ShortDeviceHeight')) {
                            this._shortHeight = mainConfig.ShortDeviceHeight;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("set short height from main config: " + this._shortHeight);
                            }
                        }
                    }
                    if (this._narrowWidth == null) {
                        this._narrowWidth = DEFAULT_NARROW_WIDTH;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("set narrow width from default: " + this._narrowWidth);
                        }
                    }
                    if (this._shortHeight == null) {
                        this._shortHeight = DEFAULT_SHORT_HEIGHT;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("set short height from default: " + this._shortHeight);
                        }
                    }
                };
                this.getWptSpinner = (callback) => {
                    this._log.info("HelperFunctions.getWptSpinner()");
                    if (this._spinnerSvg == null) {
                        this._core.Loader.getVersionedHTML('./assets/images/wpt-spinner.svg', this._receiveSpinner.bind(this, callback), this.missingHtmlErrorCallback);
                    }
                    else {
                        if (callback) {
                            callback(this._spinnerSvg);
                        }
                    }
                };
                this.prepareHourglassIcon = (element) => {
                    this._log.info("HelperFunctions.prepareHourglassIcon()");
                    let callback = this._fillHourglassIcon.bind(this, element);
                    this.getWptSpinner(callback);
                };
                this.prepareWptLoader = (element, classes) => {
                    this._log.info("HelperFunctions.prepareWptLoader()");
                    let callback = this._fillWptLoader.bind(this, element, classes);
                    this.getWptSpinner(callback);
                };
                /**
                 * Sets the inner HTML of the element found by the selector to the translated string.
                 * @param elementSelector CSS selector for an element
                 * @param translationString string for which translation is searched
                 * @see WPTNamespace.LocaleNamespace.LocaleClass.getTranslation
                 */
                this.setTranslation = (elementSelector, translationString) => {
                    this._log.info("HelperFunctions.setTranslation()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("setting translation for element selector: " + elementSelector);
                    }
                    let element = document.querySelector(elementSelector);
                    if (element) {
                        this.setElementTranslation(element, translationString);
                    }
                    else {
                        console.warn("no element found for element selector: " + elementSelector);
                    }
                };
                this.setElementTranslation = (element, translationString) => {
                    this._log.info("HelperFunctions.setElementTranslation()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("setting translation for element: " + element.id);
                    }
                    element.innerHTML = this._core.Locale.getTranslation(translationString);
                };
                /**
                 * Sets the value for the attribute of the element found by the selector to the translated string.
                 * @param elementSelector CSS selector for an element
                 * @param attributeName name of the attribute
                 * @param translationString string for which translation is searched
                 * @see WPTNamespace.LocaleNamespace.LocaleClass.getTranslation
                 */
                this.setTranslationAttribute = (elementSelector, attributeName, translationString) => {
                    this._log.info("HelperFunctions.setTranslationAttribute()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("setting translation for element selector: " + elementSelector);
                    }
                    let element = document.querySelector(elementSelector);
                    if (element) {
                        this.setElementTranslationAttribute(element, attributeName, translationString);
                    }
                    else {
                        console.warn("no element found for element selector: " + elementSelector);
                    }
                };
                this.setElementTranslationAttribute = (element, attributeName, translationString) => {
                    this._log.info("HelperFunctions.setElementTranslationAttribute()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("setting translation for element: " + element.id);
                        this._log.trace("setting translation for attribute: " + attributeName);
                    }
                    element.setAttribute(attributeName, this._core.Locale.getTranslation(translationString));
                };
                /**
                 * Error callback for missing HTML files. Shows warning message in a modal.
                 * @param url URL used to get the HTML file
                 * @param status HTTP status code
                 * @param statusText HTTP status text
                 */
                this.missingHtmlErrorCallback = (url, status, statusText) => {
                    this._log.info("HelperFunctions.missingHtmlErrorCallback()");
                    let msgBody = this._core.Locale.getTranslation('STR_WPT_MISSING_HTML_MSG');
                    this.presentWarningModal(msgBody + " - " + url + ": " + status + " - " + statusText);
                };
                /**
                 * Error callback for missing JSON files. Shows warning message in a modal.
                 * @param url URL used to get the JSON file
                 * @param status HTTP status code
                 * @param statusText HTTP status text
                 */
                this.missingJsonErrorCallback = (url, status, statusText) => {
                    this._log.info("HelperFunctions.missingJsonErrorCallback()");
                    let msgBody = this._core.Locale.getTranslation('STR_WPT_MISSING_JSON_MSG');
                    this.presentWarningModal(msgBody + " - " + url + ": " + status + " - " + statusText);
                };
                /**
                 * Shows a message in a modal.
                 * @param modalType the modal type to request
                 * @param message message (gets translated) to use for the modal
                 * @param title optional title (gets translated) to use for the modal, default is 'STR_WPT_MESSAGE'
                 * @param modalConfig optional configuration for the modal
                 */
                this.presentMessageModal = (modalType, message, title = 'STR_WPT_MESSAGE', modalConfig = new WPTNamespace.ModalShowConfig()) => {
                    this._log.info("HelperFunctions.presentMessageModal()");
                    let modalSession = 'message-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(modalType, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentMessageModalSession = modalSession;
                        let callback = this._displayMessageModal.bind(this, 'wpt-modal--accent', title, message, modalConfig);
                        if (this._messageModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/messageModal.html', this._storeMessageHtml.bind(this, callback), this.missingHtmlErrorCallback);
                        }
                        else {
                            callback();
                        }
                    }
                    else {
                        console.error("unable to show message modal, modal placeholder is already used");
                    }
                };
                this.presentIdPBusyModal = (message, title = 'STR_WPT_PLEASE_WAIT') => {
                    this._log.info("HelperFunctions.presentIdPBusyModal()");
                    if (this._idpBusyModalActive) {
                        console.error("IdP busy modal already displayed");
                        return;
                    }
                    let modalSession = 'idp-busy-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.ERROR, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentIdPBusyModalSession = modalSession;
                        this._idpBusyModalActive = true;
                        let callback = this._displayIdPBusyModal.bind(this, title, message);
                        if (this._idpBusyModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/idpBusyModal.html', this._storeIdPBusyHtml.bind(this, callback), this.missingHtmlErrorCallback);
                        }
                        else {
                            callback();
                        }
                    }
                    else {
                        console.error("unable to show IdP busy modal, modal placeholder is already used");
                    }
                };
                this.closeIdPBusyModal = (callback = null) => {
                    this._log.info("HelperFunctions.closeIdPBusyModal()");
                    if (this._idpBusyModalActive) {
                        if (callback) {
                            let modal = this._core.getModal(this._currentIdPBusyModalSession);
                            modal.JQ.one('hidden.bs.modal', function () {
                                callback();
                            });
                        }
                        this._core.hideModal(this._currentIdPBusyModalSession);
                        this._idpBusyModalActive = false;
                    }
                };
                /**
                 * Shows a busy message in a modal.
                 * @param modalType the modal type to request
                 * @param modalSession the modal session to request
                 * @param message message (gets translated) to use for the modal
                 * @param title optional title (gets translated) to use for the modal, default is 'STR_WPT_PLEASE_WAIT'
                 * @returns TRUE if modal could be requested, otherwise FALSE
                 */
                this.presentBusyModal = (modalType, modalSession, message, title = 'STR_WPT_PLEASE_WAIT') => {
                    this._log.info("HelperFunctions.presentBusyModal()");
                    let modal = this._core.requestModal(modalType, modalSession);
                    if (modal !== null && modal !== undefined) {
                        let callback = this._displayBusyModal.bind(this, modalSession, title, message);
                        if (this._busyModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/busyModal.html', this._storeBusyHtml.bind(this, callback), this.missingHtmlErrorCallback);
                        }
                        else {
                            callback();
                        }
                        return true;
                    }
                    else {
                        console.error("unable to show busy modal, modal placeholder is already used");
                        return false;
                    }
                };
                /**
                 * Closes a busy modal.
                 * @param modalSession the modal session to close
                 */
                this.closeBusyModal = (modalSession) => {
                    this._log.info("HelperFunctions.closeBusyModal()");
                    let readyIndex = this._busyModalsReady.indexOf(modalSession);
                    if (readyIndex > -1) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("modal '" + modalSession + "' is ready, closing...");
                        }
                        this._core.hideModal(modalSession);
                        this._busyModalsReady.splice(readyIndex, 1);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("modal '" + modalSession + "' isn't ready, requesting...");
                        }
                        this._busyModalsCloseRequested.push(modalSession);
                    }
                };
                /**
                 * Shows a warning message in a modal.
                 * @param message message (gets translated) to use for the modal
                 * @param title optional title (gets translated) to use for the modal, default is 'STR_WPT_WARNING'
                 */
                this.presentWarningModal = (message, title = 'STR_WPT_WARNING') => {
                    this._log.info("HelperFunctions.presentWarningModal()");
                    let modalSession = 'warning-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.ERROR, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentMessageModalSession = modalSession;
                        let callback = this._displayMessageModal.bind(this, 'wpt-modal--warn', title, message);
                        if (this._messageModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/messageModal.html', this._storeMessageHtml.bind(this, callback), this.missingHtmlErrorCallback);
                        }
                        else {
                            callback();
                        }
                    }
                    else {
                        console.error("unable to show warning modal, modal placeholder is already used");
                    }
                };
                /**
                 * Shows a success message in a modal.
                 * @param modalType the modal type to request
                 * @param message message (gets translated) to use for the modal
                 * @param title optional title (gets translated) to use for the modal, default is 'STR_WPT_SUCCESSFUL'
                 */
                this.presentSuccessModal = (modalType, message, title = 'STR_WPT_SUCCESSFUL') => {
                    this._log.info("HelperFunctions.presentSuccessModal()");
                    let modalSession = 'success-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(modalType, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentMessageModalSession = modalSession;
                        let callback = this._displayMessageModal.bind(this, 'wpt-modal--success', title, message);
                        if (this._messageModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/messageModal.html', this._storeMessageHtml.bind(this, callback), this.missingHtmlErrorCallback);
                        }
                        else {
                            callback();
                        }
                    }
                    else {
                        console.error("unable to show success modal, modal placeholder is already used");
                    }
                };
                /**
                 * Shows a warning message in a modal with the option to continue.
                 * @param continueFn function to call, when user decides to 'continue'
                 * @param message message (gets translated) to use for the modal
                 * @param title optional title (gets translated) to use for the modal, default is 'STR_WPT_WARNING'
                 */
                this.presentWarningContinueModal = (message, continueFn, title = 'STR_WPT_WARNING', cancelFn = null) => {
                    this._log.info("HelperFunctions.presentWarningContinueModal()");
                    let modalSession = 'warning-continue-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.ERROR, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentMessageModalSession = modalSession;
                        let callback = this._displayWarningContinueModal.bind(this, title, message, continueFn, cancelFn);
                        if (this._warnContModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/warningContinue.html', this._storeWarnContHtml.bind(this, callback), this.missingHtmlErrorCallback);
                        }
                        else {
                            callback();
                        }
                    }
                    else {
                        console.error("unable to show warning-continue modal, modal placeholder is already used");
                    }
                };
                /**
                 * Shows a service warning message in a modal.
                 * @param error error title (gets translated) to use for the modal
                 * @param status status text (gets translated) to use for the modal
                 * @param message message to use for the modal
                 * @param hiddenFn optional function to call, when the modal is closed
                 * @param title optional title (gets translated) to use for the modal, default is 'STR_WPT_WARNING'
                 */
                this.presentWarningServiceModal = (error, status, message, hiddenFn = null, title = 'STR_WPT_WARNING') => {
                    this._log.info("HelperFunctions.presentWarningServiceModal()");
                    let modalSession = 'warning-service-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(WPTNamespace.ModalType.ERROR, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentMessageModalSession = modalSession;
                        let callback = this._displayWarningServiceModal.bind(this, title, error, status, message, hiddenFn);
                        if (this._warnServiceModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/warningService.html', this._storeWarnServiceHtml.bind(this, callback), this.missingHtmlErrorCallback);
                        }
                        else {
                            callback();
                        }
                    }
                    else {
                        console.error("unable to show warning-service modal, modal placeholder is already used");
                    }
                };
                this.presentAutofillDatasetSelectionModal = (modalType, datasets, callback) => {
                    this._log.info("HelperFunctions.presentAutofillDatasetSelectionModal()");
                    let modalSession = 'data-selection-modal-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    let modal = this._core.requestModal(modalType, modalSession);
                    if (modal !== null && modal !== undefined) {
                        this._currentDataSelectionModalSession = modalSession;
                        let displayCallback = this._displayAutofillDatasetSelectionModal.bind(this, datasets, callback);
                        if (this._datasetSelectionModalHtml === null) {
                            this._core.Loader.getVersionedHTML('assets/wpt/html/datasetSelectionModal.html', this._storeDataSelectionHtml.bind(this, displayCallback), this.missingHtmlErrorCallback);
                        }
                        else {
                            displayCallback();
                        }
                    }
                    else {
                        console.error("unable to show dataset selection modal, modal placeholder is already used");
                    }
                };
                this.getButtonIcon = (identifier) => {
                    this._log.info("HelperFunctions.getButtonIcon()");
                    let mapping = null;
                    let buttonIcon = null;
                    switch (identifier.Type) {
                        case "AdHocTask":
                            mapping = this._iconMapping.find(map => ((map.IconIdentifier.Type == 'AdHocTask') && (map.IconIdentifier.Name == identifier.Name)
                                && (map.IconIdentifier.Queue == identifier.Queue) && (map.IconIdentifier.Lifecycle == identifier.Lifecycle)));
                            break;
                        case "DocAction":
                            mapping = this._iconMapping.find(map => ((map.IconIdentifier.Type == 'DocAction') && (map.IconIdentifier.Name == identifier.Name)));
                            break;
                        case "SysTask":
                            mapping = this._iconMapping.find(map => ((map.IconIdentifier.Type == 'SysTask') && (map.IconIdentifier.Name == identifier.Name)));
                            break;
                        case "Application":
                            mapping = this._iconMapping.find(map => ((map.IconIdentifier.Type == 'Application') && (map.IconIdentifier.Name == identifier.Name)));
                            break;
                        case "DetailView":
                            mapping = this._iconMapping.find(map => ((map.IconIdentifier.Type == 'DetailView') && (map.IconIdentifier.Name == identifier.Name)));
                            break;
                        case "URL":
                            mapping = this._iconMapping.find(map => ((map.IconIdentifier.Type == 'URL') && (map.IconIdentifier.Name == identifier.Name)));
                            break;
                        case "WvAction":
                            mapping = this._iconMapping.find(map => ((map.IconIdentifier.Type == 'WvAction') && (map.IconIdentifier.Name == identifier.Name)
                                && (map.IconIdentifier.Class == identifier.Class) && (map.IconIdentifier.Application == identifier.Application)));
                            break;
                        default:
                            console.warn("unknown icon identifier type: " + identifier.Type);
                            break;
                    }
                    if (mapping) {
                        buttonIcon = mapping.Icon;
                    }
                    return buttonIcon;
                };
                /**
                 * Looks for themes in UserProfile (first for application, then default for gateway) and requests them if found.
                 * @returns `true` if a theme was found and requested, `false` otherwise
                 */
                this.requestTheme = () => {
                    this._log.info("HelperFunctions.requestTheme()");
                    let themeRequested = false;
                    let instanceName = this._core.Config.getMainConfig().InstanceName;
                    let themeName = this._core.GetUserProfileConfigVar(`Theme:${instanceName}|${this._core.Config.getSelectedApplication().Name}`.toUpperCase());
                    // if no app-specific theme, see if we have a default set for the gateway globally
                    if (!themeName)
                        themeName = this._core.GetUserProfileConfigVar(`Theme:${instanceName}|${WPTNamespace.DEFAULT_THEME_TAG}`.toUpperCase());
                    if (themeName) {
                        if (this._log !== null && this._log.isTraceEnabled()) {
                            this._log.trace(`User has theme setting '${themeName}' for selected application (or global default)`);
                        }
                        themeRequested = this._core.Config.SelectTheme(themeName);
                    }
                    return themeRequested;
                };
                this._storeMessageHtml = (callback, htmlData) => {
                    this._log.info("HelperFunctions._storeMessageHtml()");
                    this._messageModalHtml = htmlData;
                    callback();
                };
                /**
                 * Displays message modal.
                 * @param messageClass CSS class for the type of message (wpt-modal)
                 * @param title title (gets translated) to use for the modal
                 * @param message message (gets translated) to use for the modal
                 */
                this._displayMessageModal = (messageClass, title, message, modalConfig) => {
                    this._log.info("HelperFunctions._displayMessageModal()");
                    let modal = this._core.getModal(this._currentMessageModalSession);
                    modal.DIV.innerHTML = this._messageModalHtml;
                    modal.DIV.querySelector('#messageModal').classList.add(messageClass);
                    this.setElementTranslation(modal.DIV.querySelector('#messageTitle'), title);
                    this.setElementTranslation(modal.DIV.querySelector('#messageBody'), message);
                    this.setElementTranslation(modal.DIV.querySelector('#messageCloseButtonLabel'), 'STR_WPT_CLOSE');
                    this._core.showModal(this._currentMessageModalSession, modalConfig);
                };
                this._storeIdPBusyHtml = (callback, htmlData) => {
                    this._log.info("HelperFunctions._storeIdPBusyHtml()");
                    this._idpBusyModalHtml = htmlData;
                    callback();
                };
                this._displayIdPBusyModal = (title, message) => {
                    this._log.info("HelperFunctions._displayIdPBusyModal()");
                    let modal = this._core.getModal(this._currentIdPBusyModalSession);
                    modal.DIV.innerHTML = this._idpBusyModalHtml;
                    this._core.Helper.prepareHourglassIcon(modal.DIV);
                    this.setElementTranslation(modal.DIV.querySelector('#idpBusyTitle'), title);
                    this.setElementTranslation(modal.DIV.querySelector('#idpBusyMessage'), message);
                    // show modal and don't allow to be closed
                    let showConfig = new WPTNamespace.ModalShowConfig();
                    showConfig.NotClosable = true;
                    this._core.showModal(this._currentIdPBusyModalSession, showConfig);
                };
                this._storeBusyHtml = (callback, htmlData) => {
                    this._log.info("HelperFunctions._storeBusyHtml()");
                    this._busyModalHtml = htmlData;
                    callback();
                };
                /**
                 * Displays busy message modal.
                 * @param title title (gets translated) to use for the modal
                 * @param message message (gets translated) to use for the modal
                 */
                this._displayBusyModal = (modalSession, title, message) => {
                    this._log.info("HelperFunctions._displayBusyModal()");
                    let modal = this._core.getModal(modalSession);
                    modal.DIV.innerHTML = this._busyModalHtml;
                    modal.JQ.one('shown.bs.modal', this._busyModalReady.bind(this, modalSession));
                    this._core.Helper.prepareHourglassIcon(modal.DIV);
                    this.setElementTranslation(modal.DIV.querySelector('#busyHeading'), title);
                    this.setElementTranslation(modal.DIV.querySelector('#busyLabel'), message);
                    let showConfig = new WPTNamespace.ModalShowConfig();
                    showConfig.NotClosable = true;
                    this._core.showModal(modalSession, showConfig);
                };
                this._busyModalReady = (modalSession) => {
                    this._log.info("HelperFunctions._busyModalReady()");
                    let closeIndex = this._busyModalsCloseRequested.indexOf(modalSession);
                    if (closeIndex > -1) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("modal '" + modalSession + "' close requested, closing...");
                        }
                        this._core.hideModal(modalSession);
                        this._busyModalsCloseRequested.splice(closeIndex, 1);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("modal '" + modalSession + "' set as ready...");
                        }
                        this._busyModalsReady.push(modalSession);
                    }
                };
                this._storeWarnContHtml = (callback, htmlData) => {
                    this._log.info("HelperFunctions._storeWarnContHtml()");
                    this._warnContModalHtml = htmlData;
                    callback();
                };
                /**
                 * Displays warning continue message modal.
                 * @param title title (gets translated) to use for the modal
                 * @param message message (gets translated) to use for the modal
                 * @param continueFn function to call, when user decides to 'continue'
                 */
                this._displayWarningContinueModal = (title, message, continueFn, cancelFn = null) => {
                    this._log.info("HelperFunctions._displayWarningContinueModal()");
                    let modal = this._core.getModal(this._currentMessageModalSession);
                    modal.DIV.innerHTML = this._warnContModalHtml;
                    let continueButton = modal.DIV.querySelector('#warningContinueButton');
                    let cancelButton = modal.DIV.querySelector('#warningCloseButton');
                    this.setElementTranslation(modal.DIV.querySelector('#warningTitle'), title);
                    this.setElementTranslation(modal.DIV.querySelector('#warningBody'), message);
                    this.setElementTranslation(modal.DIV.querySelector('#warningCloseButtonLabel'), 'STR_WPT_CANCEL');
                    this.setElementTranslation(continueButton.querySelector('#warningContinueButtonLabel'), 'STR_WPT_CONTINUE');
                    let helper = this;
                    let continueListener = function () {
                        modal.JQ.one('hidden.bs.modal', function () {
                            continueFn();
                        });
                        helper._core.hideModal(helper._currentMessageModalSession);
                    };
                    continueButton.addEventListener('click', continueListener);
                    if (cancelFn) {
                        let cancelListener = function () {
                            modal.JQ.one('hidden.bs.modal', function () {
                                cancelFn();
                            });
                            helper._core.hideModal(helper._currentMessageModalSession);
                        };
                        cancelButton.addEventListener('click', cancelListener);
                    }
                    helper._core.showModal(helper._currentMessageModalSession);
                };
                this._storeWarnServiceHtml = (callback, htmlData) => {
                    this._log.info("HelperFunctions._storeWarnServiceHtml()");
                    this._warnServiceModalHtml = htmlData;
                    callback();
                };
                /**
                 * Displays service warning message modal.
                 * @param title title (gets translated) to use for the modal
                 * @param error error title (gets translated) to use for the modal
                 * @param status status text (gets translated) to use for the modal
                 * @param message message to use for the modal
                 * @param hiddenFn optional function to call, when the modal is closed
                 * @param htmlData HTML for the modal
                 */
                this._displayWarningServiceModal = (title, error, status, message, hiddenFn) => {
                    this._log.info("HelperFunctions._displayWarningServiceModal()");
                    let modal = this._core.getModal(this._currentMessageModalSession);
                    modal.DIV.innerHTML = this._warnServiceModalHtml;
                    let text = modal.DIV.querySelector("#responseText");
                    let fullMessage = modal.DIV.querySelector('#fullMessage');
                    let messageToggler = modal.DIV.querySelector('#showFullMessage');
                    this.setElementTranslation(modal.DIV.querySelector('#warningTitle'), title);
                    this.setElementTranslation(modal.DIV.querySelector('#errorLabel'), error);
                    this.setElementTranslation(modal.DIV.querySelector('#statusLabel'), status);
                    this.setElementTranslation(modal.DIV.querySelector('#warningCloseButtonLabel'), 'STR_WPT_CLOSE');
                    this.setElementTranslation(messageToggler, "STR_WPT_SHOW_DETAILS");
                    this.setElementTranslation(modal.DIV.querySelector('#helpMessage'), "STR_WPT_HELP_DETAILS");
                    text.value = message;
                    let helper = this;
                    messageToggler.addEventListener('click', function () {
                        if (fullMessage.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                            fullMessage.classList.remove(WPTNamespace.HIDDEN_CLASS);
                            helper.setElementTranslation(messageToggler, "STR_WPT_HIDE_DETAILS");
                        }
                        else {
                            fullMessage.classList.add(WPTNamespace.HIDDEN_CLASS);
                            helper.setElementTranslation(messageToggler, "STR_WPT_SHOW_DETAILS");
                        }
                    });
                    if (window.ResizeObserver) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("HelperFunctions._displayWarningServiceModal(): browser supports ResizeObserver");
                        }
                        let resizeObserver = new ResizeObserver(this._setWarningServiceDetailHeight.bind(this, text));
                        resizeObserver.observe(text);
                    }
                    else {
                        console.warn("browser doesn't support ResizeObserver");
                    }
                    if (hiddenFn) {
                        modal.JQ.one('hidden.bs.modal', function () {
                            hiddenFn();
                        });
                    }
                    this._core.showModal(this._currentMessageModalSession);
                };
                this._setWarningServiceDetailHeight = (text) => {
                    this._log.info("HelperFunctions._setWarningServiceDetailHeight()");
                    let height = text.scrollHeight;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("HelperFunctions._setWarningServiceDetailHeight(): got scrollHeight: " + height);
                    }
                    let borderHeight = this._core.Functions.getElementBorderHeight(text);
                    height += borderHeight;
                    text.style.height = height + "px";
                };
                this._storeDataSelectionHtml = (callback, htmlData) => {
                    this._log.info("HelperFunctions._storeDataSelectionHtml()");
                    this._datasetSelectionModalHtml = htmlData;
                    callback();
                };
                this._displayAutofillDatasetSelectionModal = (datasets, callback) => {
                    this._log.info("HelperFunctions._displayAutofillDatasetSelectionModal()");
                    let modal = this._core.getModal(this._currentDataSelectionModalSession);
                    modal.DIV.innerHTML = this._datasetSelectionModalHtml;
                    let tableHolder = modal.DIV.querySelector('#datasetContent');
                    let showFilter = modal.DIV.querySelector('.showFilter');
                    let hideFilter = modal.DIV.querySelector('.hideFilter');
                    this.setElementTranslation(modal.DIV.querySelector('#datasetSelectionHeading'), "STR_WPT_CHOOSEDATASET_TITLE");
                    this.setElementTranslation(modal.DIV.querySelector('#datasetMessage'), "STR_WPT_CHOOSEDATASET_MSG");
                    this.setElementTranslation(modal.DIV.querySelector('#datasetSelectionCloseButtonLabel'), 'STR_WPT_CLOSE');
                    let dataTable = new WPTNamespace.Widgets.ComponentDataTable(this._core, tableHolder, null);
                    dataTable.present();
                    let columns = [];
                    let headerSet = datasets[0];
                    let length = headerSet.Keywords.length;
                    for (let i = 0; i < length; i++) {
                        let keyword = headerSet.Keywords[i];
                        let setting = {
                            Title: keyword.Name
                        };
                        columns.push(setting);
                    }
                    let rows = [];
                    let dataLength = datasets.length;
                    for (let d = 0; d < dataLength; d++) {
                        let dataset = datasets[d];
                        let metaValues = [];
                        let rowValues = [];
                        let rowData = {
                            Values: rowValues,
                            Metadata: metaValues,
                            ClickCallback: this._selectedAutofillDatasetSelectionModal.bind(this, dataset, callback)
                        };
                        length = dataset.Keywords.length;
                        for (let i = 0; i < length; i++) {
                            let keyword = dataset.Keywords[i];
                            let cellValue = this.convertKeywordToDatatableCell(keyword, columns[i]);
                            rowValues.push(cellValue);
                        }
                        rows.push(rowData);
                    }
                    let tableData = {
                        Columns: columns,
                        Rows: rows
                    };
                    dataTable.displayData(tableData);
                    showFilter.addEventListener('click', this._toggleDatasetSelectionFilter.bind(this, true, showFilter, hideFilter, dataTable));
                    hideFilter.addEventListener('click', this._toggleDatasetSelectionFilter.bind(this, false, showFilter, hideFilter, dataTable));
                    this._core.showModal(this._currentDataSelectionModalSession);
                };
                this._toggleDatasetSelectionFilter = (show, showFilter, hideFilter, dataTable) => {
                    this._log.info("HelperFunctions._showDatasetSelectionFilter()");
                    if (show) {
                        this._core.Functions.showElement(hideFilter);
                        this._core.Functions.hideElement(showFilter);
                        dataTable.showFilterRow();
                    }
                    else {
                        this._core.Functions.showElement(showFilter);
                        this._core.Functions.hideElement(hideFilter);
                        dataTable.hideFilterRow();
                    }
                };
                this._selectedAutofillDatasetSelectionModal = (dataset, callback) => {
                    this._log.info("HelperFunctions._selectedAutofillDatasetSelectionModal()");
                    this._core.hideModal(this._currentDataSelectionModalSession);
                    if (callback) {
                        callback(dataset);
                    }
                };
                /**
                 * Function used to decide whether the display space is small (default: width < 768 or height < 768).
                 * @returns 'true' for small devices, otherwise 'false'
                 */
                this.isSmallDevice = () => {
                    this._log.info("HelperFunctions.isSmallDevice()");
                    if (this.isNarrowDevice() || this.isShortDevice()) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("small device");
                        }
                        return true;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("no small device");
                    }
                    return false;
                };
                /**
                 * Function used to decide whether the display space is narrow (default: width < 768).
                 * @returns 'true' for narrow devices, otherwise 'false'
                 */
                this.isNarrowDevice = () => {
                    this._log.info("HelperFunctions.isNarrowDevice()");
                    if (window.innerWidth < this._narrowWidth) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("narrow device");
                        }
                        return true;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("no narrow device");
                    }
                    return false;
                };
                /**
                 * Function used to decide whether the display space is short (default: height < 768).
                 * @returns 'true' for short devices, otherwise 'false'
                 */
                this.isShortDevice = () => {
                    this._log.info("HelperFunctions.isShortDevice()");
                    if (window.innerHeight < this._shortHeight) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("short device");
                        }
                        return true;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("no short device");
                    }
                    return false;
                };
                /**
                 * Used by the invertColour and contrastText calls to push names into standard hex notation
                 * @param colour: HTML colour string, could be name or hex
                 */
                this._standardiseColour = (colour) => {
                    this._log.info("HelperFunctions._standardiseColour()");
                    let canvas = document.createElement('canvas');
                    let iscontext = canvas.getContext("2d");
                    if (iscontext) {
                        let context = iscontext;
                        context.fillStyle = colour;
                        return context.fillStyle;
                    }
                    else {
                        return '';
                    }
                };
                this.invertColour = (colour) => {
                    this._log.info("HelperFunctions.invertColour()");
                    // Cope with named colours
                    colour = this._standardiseColour(colour);
                    // remove # and ensure 6-character representation
                    if (colour.indexOf('#') === 0)
                        colour = colour.slice(1);
                    if (colour.length === 3)
                        colour = colour[0] + colour[0] + colour[1] + colour[1] + colour[2] + colour[2];
                    if (colour.length !== 6)
                        throw new Error('Invalid HEX color.');
                    let r = parseInt(colour.slice(0, 2), 16);
                    let g = parseInt(colour.slice(2, 4), 16);
                    let b = parseInt(colour.slice(4, 6), 16);
                    // Invert each segment and zero-pad
                    let red = `0${(255 - r).toString(16)}`.slice(-2);
                    let green = `0${(255 - g).toString(16)}`.slice(-2);
                    let blue = `0${(255 - b).toString(16)}`.slice(-2);
                    return "#" + red + green + blue;
                };
                this.contrastText = (colour) => {
                    this._log.info("HelperFunctions.contrastText()");
                    // Cope with named colours
                    colour = this._standardiseColour(colour);
                    // remove # and ensure 6-character representation
                    if (colour.indexOf('#') === 0)
                        colour = colour.slice(1);
                    if (colour.length === 3)
                        colour = colour[0] + colour[0] + colour[1] + colour[1] + colour[2] + colour[2];
                    if (colour.length !== 6)
                        throw new Error('Invalid HEX color.');
                    let r = parseInt(colour.slice(0, 2), 16);
                    let g = parseInt(colour.slice(2, 4), 16);
                    let b = parseInt(colour.slice(4, 6), 16);
                    return ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? '#000000' : '#FFFFFF';
                };
                this.zeroPad = (val, size) => {
                    this._log.info("HelperFunctions.zeroPad()");
                    if (size > 16)
                        size = 16;
                    return `0000000000000000${val.toString()}`.slice(0 - size);
                };
                this.validateFileFormat = (extension) => {
                    this._log.info("HelperFunctions.validateFileFormat()");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('Upload') && appConfig.Upload.hasOwnProperty('AllowedFileTypes') && appConfig.Upload.AllowedFileTypes.length > 0) {
                        let format = extension.toLowerCase();
                        let allowedLength = appConfig.Upload.AllowedFileTypes.length;
                        for (let i = 0; i < allowedLength; i++) {
                            let allowedFileType = appConfig.Upload.AllowedFileTypes[i];
                            if (format === allowedFileType.toLowerCase()) {
                                return true;
                            }
                        }
                    }
                    return false;
                };
                this.validateFileSize = (fileSize) => {
                    this._log.info("HelperFunctions.validateFileSize()");
                    let appConfig = this._core.Config.getApplicationConfig();
                    if (appConfig.hasOwnProperty('Upload') && appConfig.Upload.hasOwnProperty('MaxUploadSizeBytes')) {
                        if (fileSize <= appConfig.Upload.MaxUploadSizeBytes) {
                            return true;
                        }
                    }
                    return false;
                };
                this.convertKeywordToDatatableCell = (keyword, columnSetting) => {
                    this._log.info("HelperFunctions.convertKeywordToDatatableCell()");
                    let value = keyword.Value;
                    let cellValue = {
                        Value: value,
                        Display: value,
                        Sort: value,
                        Filter: value
                    };
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at value: " + value);
                    }
                    switch (keyword.Type) {
                        case "Date":
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at type: Date");
                            }
                            if (value != "") {
                                let dateValue = this._core.Functions.getTimezoneCorrectedDateTime(value + "T00:00:00");
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("got date value: " + dateValue);
                                }
                                cellValue.Sort = dateValue.getTime();
                                cellValue.Value = dateValue.getTime();
                                let dateString = this._core.Locale.DateFormatter.format(dateValue);
                                cellValue.Display = dateString;
                                cellValue.Filter = value + " " + dateString;
                                if (columnSetting.hasOwnProperty('FilterType') && columnSetting.FilterType === "Select") {
                                    cellValue.Filter = dateString;
                                    cellValue.Value = dateString;
                                }
                            }
                            break;
                        case "DateTime":
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at type: DateTime");
                            }
                            if (value != "") {
                                let dateValue = this._core.Functions.getTimezoneCorrectedDateTime(value);
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("got date/time value: " + dateValue);
                                }
                                cellValue.Sort = dateValue.getTime();
                                cellValue.Value = dateValue.getTime();
                                let dateString = this._core.Locale.DatetimeFormatter.format(dateValue);
                                cellValue.Display = dateString;
                                cellValue.Filter = value + " " + dateString;
                                if (columnSetting.hasOwnProperty('FilterType') && columnSetting.FilterType === "Select") {
                                    cellValue.Filter = dateString;
                                    cellValue.Value = dateString;
                                }
                            }
                            break;
                        case "Numeric9":
                        case "Numeric20":
                        case "FloatingPoint":
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at type: Numeric9 | Numeric20 | FloatingPoint");
                            }
                            if (value != "") {
                                let numberValue = new Number(value);
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("got number value: " + numberValue);
                                }
                                cellValue.Value = numberValue;
                                cellValue.Sort = numberValue;
                                let numberValueString = this._core.Locale.NumberFormatter.format(numberValue.valueOf());
                                cellValue.Display = numberValueString;
                                let numberValueNoGrouping = this._core.Locale.NumberNoGroupingFormatter.format(numberValue.valueOf());
                                cellValue.Filter = numberValue + " " + numberValueString + " " + numberValueNoGrouping;
                                if (columnSetting.hasOwnProperty('FilterType') && columnSetting.FilterType === "Select") {
                                    cellValue.Filter = numberValueString;
                                    cellValue.Value = numberValueString;
                                }
                            }
                            break;
                        case "Currency":
                        case "SpecificCurrency":
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("looking at type: Currency | SpecificCurrency");
                            }
                            if (value != "") {
                                let currencyValue = new Number(value);
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("got currency value: " + currencyValue);
                                }
                                cellValue.Value = currencyValue;
                                cellValue.Sort = currencyValue;
                                let currencyValueString = this._core.Locale.CurrencyFormatter.format(currencyValue.valueOf());
                                cellValue.Display = currencyValueString;
                                let currencyValueNoGrouping = this._core.Locale.CurrencyNoGroupingFormatter.format(currencyValue.valueOf());
                                cellValue.Filter = currencyValue + " " + currencyValueString + " " + currencyValueNoGrouping;
                                if (columnSetting.hasOwnProperty('FilterType') && columnSetting.FilterType === "Select") {
                                    cellValue.Filter = currencyValueString;
                                    cellValue.Value = currencyValueString;
                                }
                            }
                            break;
                    }
                    return cellValue;
                };
                this.getWvViewConfigForApplication = (viewConfigFile, application) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("HelperFunctions.getWvViewConfigForApplication()");
                    let viewConfig = yield this._getWvViewConfiguration(viewConfigFile);
                    return this._getWvApplicationConfig(viewConfig, application);
                });
                this.getWvViewConfigForClass = (viewConfigFile, application, clazz) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("HelperFunctions.getWvViewConfigForClass()");
                    let viewConfig = yield this._getWvViewConfiguration(viewConfigFile);
                    return this._getWvClassConfig(viewConfig, application, clazz);
                });
                this.getWvFormForId = (formId) => __awaiter(this, void 0, void 0, function* () {
                    this._log.info("HelperFunctions.getWvFormForId()");
                    if (formId && formId.length > 0) {
                        let wvForm = this._wvFormMap[formId];
                        if (wvForm == null || wvForm == undefined) {
                            wvForm = null;
                            let instance = this;
                            let promiseFn = function (resolve, reject) {
                                return __awaiter(this, void 0, void 0, function* () {
                                    let getWorkViewForm = function (textData) {
                                        if (instance._log.isTraceEnabled()) {
                                            instance._log.trace("get WorkView form function");
                                        }
                                        wvForm = textData.ContentText;
                                    };
                                    if (instance._log.isTraceEnabled()) {
                                        instance._log.trace("getting WorkView form and calling get WorkView form function");
                                    }
                                    let url = "/GetWvHtmlForm.ashx?id=" + instance._core.Functions.safeEncodeURIComponent(formId);
                                    // TODO: add error handling?
                                    instance._core.Loader.genericServiceCallTextData(url, getWorkViewForm, null, true);
                                    let counter = 0;
                                    while (wvForm == null && counter < WPTNamespace.MAX_SLEEP_INTERVALLS) {
                                        counter++;
                                        yield instance._core.Functions.sleep(instance._core.getSleepTime());
                                    }
                                    if (counter >= WPTNamespace.MAX_SLEEP_INTERVALLS) {
                                        let msg = "no WorkView form loaded during " + WPTNamespace.MAX_SLEEP_INTERVALLS + " intervals of waiting, hence aborted...";
                                        console.warn(msg);
                                        reject(msg);
                                    }
                                    else {
                                        if (instance._log.isTraceEnabled()) {
                                            instance._log.trace("finished waiting for WorkView form loaded: " + counter);
                                        }
                                        instance._wvFormMap[formId] = wvForm;
                                        resolve(wvForm);
                                    }
                                });
                            };
                            let result = new Promise(promiseFn);
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("returning promise");
                            }
                            return result;
                        }
                        else {
                            return wvForm;
                        }
                    }
                    else {
                        return null;
                    }
                });
                this._getWvViewConfiguration = (viewConfigFile) => __awaiter(this, void 0, void 0, function* () {
                    let localFile = null;
                    let identifier = null;
                    let remoteSpec = null;
                    if (viewConfigFile) {
                        if (typeof viewConfigFile !== 'object') {
                            localFile = viewConfigFile;
                            identifier = viewConfigFile;
                        }
                        else {
                            remoteSpec = viewConfigFile;
                            identifier = viewConfigFile.Instance + REMOTE_DELIMITER + viewConfigFile.FileType + REMOTE_DELIMITER + viewConfigFile.Id;
                        }
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got identifier: " + identifier);
                    }
                    if (identifier && identifier.length > 0) {
                        let viewConfig = this._wvViewConfigMap[identifier];
                        if (viewConfig == null || viewConfig == undefined) {
                            viewConfig = null;
                            let instance = this;
                            let promiseFn = function (resolve, reject) {
                                return __awaiter(this, void 0, void 0, function* () {
                                    let getViewConfiguration = function (viewConfiguration) {
                                        if (instance._log.isTraceEnabled()) {
                                            instance._log.trace("get view configuration function");
                                        }
                                        viewConfig = viewConfiguration;
                                    };
                                    if (instance._log.isTraceEnabled()) {
                                        instance._log.trace("getting view configuration file and calling get view configuration function");
                                    }
                                    if (localFile) {
                                        instance._core.Loader.getUnversionedJSON(localFile, getViewConfiguration, instance.missingJsonErrorCallback);
                                    }
                                    else {
                                        let receiveRemoteConfig = function (response) {
                                            if (instance._log.isTraceEnabled()) {
                                                instance._log.trace("receive remote config function");
                                            }
                                            getViewConfiguration(JSON.parse(response.ContentText));
                                        };
                                        instance._core.Loader.retrieveConfigData(remoteSpec, receiveRemoteConfig, instance.missingJsonErrorCallback);
                                    }
                                    let counter = 0;
                                    while (viewConfig == null && counter < WPTNamespace.MAX_SLEEP_INTERVALLS) {
                                        counter++;
                                        yield instance._core.Functions.sleep(instance._core.getSleepTime());
                                    }
                                    if (counter >= WPTNamespace.MAX_SLEEP_INTERVALLS) {
                                        let msg = "no view configuration loaded during " + WPTNamespace.MAX_SLEEP_INTERVALLS + " intervals of waiting, hence aborted...";
                                        console.warn(msg);
                                        reject(msg);
                                    }
                                    else {
                                        if (instance._log.isTraceEnabled()) {
                                            instance._log.trace("finished waiting for view configuration loaded: " + counter);
                                        }
                                        instance._wvViewConfigMap[identifier] = viewConfig;
                                        resolve(viewConfig);
                                    }
                                });
                            };
                            let result = new Promise(promiseFn);
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("returning promise");
                            }
                            return result;
                        }
                        else {
                            return viewConfig;
                        }
                    }
                    else {
                        return null;
                    }
                });
                this._getWvApplicationConfig = (viewConfig, application) => {
                    this._log.info("HelperFunctions._getWvApplicationConfig()");
                    if (viewConfig != null && viewConfig != undefined) {
                        let appConfig = viewConfig.Applications.find(app => app.Name == application);
                        if (appConfig != null && appConfig != undefined) {
                            return appConfig;
                        }
                    }
                    return null;
                };
                this._getWvClassConfig = (viewConfig, application, clazz) => {
                    this._log.info("HelperFunctions._getWvClassConfig()");
                    if (viewConfig != null && viewConfig != undefined) {
                        let appConfig = viewConfig.Applications.find(app => app.Name == application);
                        if (appConfig != null && appConfig != undefined) {
                            let classConfig = appConfig.Classes.find(cls => cls.Name == clazz);
                            if (classConfig != null && classConfig != undefined) {
                                return classConfig;
                            }
                        }
                    }
                    return null;
                };
                this._receiveSpinner = (callback, spinnerSvg) => {
                    this._log.info("HelperFunctions._receiveSpinner()");
                    this._spinnerSvg = spinnerSvg;
                    if (callback) {
                        callback(spinnerSvg);
                    }
                };
                this._fillHourglassIcon = (element, spinnerSvg) => {
                    this._log.info("HelperFunctions._fillHourglassIcon()");
                    let icon = element.querySelector('.wpt-hourglass__icon');
                    icon.innerHTML = spinnerSvg;
                };
                this._fillWptLoader = (element, classes, spinnerSvg) => {
                    this._log.info("HelperFunctions._fillWptLoader()");
                    element.innerHTML = spinnerSvg;
                    let iconSpan = document.createElement('span');
                    iconSpan.classList.add('wpt-loader__icon', ...classes.split(' '));
                    element.appendChild(iconSpan);
                };
                this.logMessageOnServer = (message, level) => {
                    this._log.info("HelperFunctions.logMessageOnServer()");
                    let logRequest = {
                        LogMessage: message,
                        Level: level
                    };
                    this._core.Loader.genericServiceCallWithData('/Config.svc/rest/LogMessage', JSON.stringify(logRequest), null);
                };
                this.logMessageOnServerSimple = (message) => {
                    this._log.info("HelperFunctions.logMessageOnServerSimple()");
                    navigator.sendBeacon(this._core.getServer() + '/Config.svc/rest/SimpleLogMessage', message);
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("HelperFunctions::constructor");
                this.init();
            }
        }
        Utilities.HelperFunctions = HelperFunctions;
    })(Utilities = WPTNamespace.Utilities || (WPTNamespace.Utilities = {}));
})(WPTNamespace || (WPTNamespace = {}));
